/**
 * @author       Yannick Deubel (https://github.com/yandeu)
 * @copyright    Copyright (c) 2020 Yannick Deubel; Project Url: https://github.com/enable3d/enable3d
 * @license      {@link https://github.com/enable3d/enable3d/blob/master/LICENSE|GNU GPLv3}
 */
import { Events } from '@yandeu/events';
export class CollisionEvents extends Events {
    addCollider(object1, object2, eventCallback) {
        if (!object1.body || !object2.body)
            return;
        object1.body.checkCollisions = true;
        object2.body.checkCollisions = true;
        this.on('collision', (data) => {
            var _a, _b;
            const { bodies, event } = data;
            if (((_a = bodies[0]) === null || _a === void 0 ? void 0 : _a.name) && ((_b = bodies[1]) === null || _b === void 0 ? void 0 : _b.name) && (object1 === null || object1 === void 0 ? void 0 : object1.name) && (object2 === null || object2 === void 0 ? void 0 : object2.name)) {
                if (bodies[0].name === object1.name && bodies[1].name === object2.name)
                    eventCallback(event);
                else if (bodies[1].name === object1.name && bodies[0].name === object2.name)
                    eventCallback(event);
            }
        });
    }
}
//# sourceMappingURL=collisionEvents.js.map